module.exports = __webpack_public_path__ + "static/img/dataAnalysis1.2f8099e3.png";